import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const ThemeContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ThemeProvider = ({ children }) => {
  const { user, token, updateUser } = useAuth();
  const [theme, setThemeState] = useState('forest');

  useEffect(() => {
    if (user?.theme) {
      setThemeState(user.theme);
      document.documentElement.setAttribute('data-theme', user.theme);
    }
  }, [user?.theme]);

  const setTheme = async (newTheme) => {
    setThemeState(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    
    if (token) {
      try {
        await fetch(`${API}/user/theme`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ theme: newTheme })
        });
        updateUser({ theme: newTheme });
      } catch (err) {
        console.error('Failed to update theme:', err);
      }
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
